import HttpRequest from "./HttpRequest"

class AlertService {

  baseUrl = '/alerts/v1/alerts'

  httpRequest = new HttpRequest()

  async getAlertById(id) {
    return this.httpRequest.get(`${this.baseUrl}/${id}`)
  }

  getWrongWorkFlowAlert(alertId) {
    return this.httpRequest.get(`alerts/v1/alerts-details/alerts/${alertId}/WRONG_WORKFLOW_DETAIL`)
  }

}

export {AlertService}



// WEBPACK FOOTER //
// ./src/services/AlertService.js